import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static {
}
$ const {
  a11yText = "Loading",
  class: inputClass,
  ...htmlInput
} = input;
<div role="img" aria-label=a11yText class=["skeleton", inputClass] ...processHtmlAttributes(htmlInput)>
  <${input.renderBody}/>
</div>